import {Component, Input, OnInit} from '@angular/core';
import {GAService} from "../../root/ga/ga.service";
import {MobileService} from "../../core/mobile.service";
import {BookingService} from "./booking.service";
import {CookieService} from "ngx-cookie";

@Component({
    selector: 'new-feature-tooltip',
    templateUrl: './new-feature-tooltip.component.html',
    providers: [GAService, BookingService, CookieService]
})
export class NewFeatureTooltipComponent implements OnInit {

    @Input() title: string;
    @Input() body: string;
    @Input() button: string;

   constructor(private mobileService: MobileService, private cookies:CookieService) {
    }

    oneTimeTooltip:boolean = true;

    ngOnInit() {
       document.addEventListener('click', (evt)=> {
            const infoTooltip = document.getElementById("info-tooltip");
                if (infoTooltip && infoTooltip.classList.contains("-show-tooltip")) {
                    infoTooltip.classList.remove('-show-tooltip');
                }
        });
    }

    ngAfterContentChecked(){
        if(this.mobileService.isMobile()){
            const featureTooltip = document.getElementById('info-tooltip');
            featureTooltip.classList.remove('pull-right');
        }

        if(this.cookies.get('mail-tooltip')){
            this.hideTooltip();
        }
    }

    closeOneTimeTooltip(e:Event){
        e.stopPropagation();
        this.cookies.put('mail-tooltip','checked');
        this.hideTooltip();

    }

    hideTooltip(){
        const tooltipInfo = document.getElementById('info-tooltip');
        tooltipInfo.classList.remove('-show-tooltip');
        if(this.mobileService.isMobile()){
            tooltipInfo.classList.add('-hide');
        }
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/new-feature-tooltip.component.ts